import React, {CSSProperties} from 'react';
import {Link} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import {Tooltip} from "./styledComponents";
import {alpha, useTheme} from "@mui/material/styles";
import {MuiColorType} from "../lib/interfaces";
import {SvgIcon} from "@mui/material";


type LabelWrapperProps = {
    children: React.ReactNode;
    label?: string;
    labelPlacement?: 'left' | 'right' | 'bottom' | 'top';
    labelEnterDelay?: number;
};

type ControlButtonProps = {
    route?: string;
    badgeContent?: React.ReactNode;
    badgeColor?: 'default' | 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning';
    icon: typeof SvgIcon;
    label?: string;
    to?: string;
    labelPlacement?: 'left' | 'right' | 'bottom' | 'top';
    labelEnterDelay?: number;
    enabled?: boolean;
    style?: React.CSSProperties;
    className?: string;
    width?: number;
    sx?: any; // specify a detailed type if it is known
    color?: MuiColorType;
    [x: string]: any; // for other props
};

function LabelWrapper(
        {
            children,
            label,
            labelPlacement,
            labelEnterDelay,
        }: LabelWrapperProps) {

    return label ? <Tooltip
            title={label}
            placement={labelPlacement}
            enterDelay={labelEnterDelay}
    >
        <span>{children}</span>
    </Tooltip> : children
}

const ControlButton = (
        {
            route,
            badgeContent,
            badgeColor,
            icon: Icon,
            label,
            to,
            labelPlacement = "bottom",
            labelEnterDelay = 200,
            enabled,
            style = {},
            className,
            width,
            sx,
            color,
            ...rest
        }: ControlButtonProps, ref: React.Ref<HTMLAnchorElement>) => {

    const theme = useTheme();

    if (enabled && theme) {
        style['backgroundColor'] = alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.2 : 0.1);
    }

    if (!color && !style["color"] && !sx?.color && theme) {
        style["color"] = theme.palette.primary.light;
    }

    const iconStyle: CSSProperties = {};

    if (width) {
        style["width"] = width + "px";
        style["height"] = width + "px";
        iconStyle["fontSize"] = width * 0.7 + "px !important";
    }

    return <LabelWrapper
            label={label}
            labelPlacement={labelPlacement}
            labelEnterDelay={labelEnterDelay}
    >
        <IconButton
                ref={ref}
                component={to ? Link : undefined}
                to={to}
                sx={{
                    fontSize: "30px !important",
                    transition:
                            "transform 0.2s ease-in-out,  opacity 0.2s ease-in-out,  color 0.2s ease-in-out",
                    transform: enabled && "scale(1.05)",
                    ...sx,
                }}
                size="large"
                style={style}
                color={color}
                {...rest}
        >
            {badgeContent ? <Badge badgeContent={badgeContent} color={badgeColor}>
                <Icon sx={iconStyle}/>

            </Badge> : <Icon
                    sx={iconStyle}
            />}
        </IconButton>
    </LabelWrapper>

};

export default React.forwardRef(ControlButton)

